import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import BackToTop from "../Back-to-top/BackToTop";

const About: React.FC = () => {
	return (
		<div>
			<Header />

			<section className="bg-img1 txt-center p-lr-15 p-tb-92" style={{ backgroundImage: `url('asset/images/bg-01.png')` }}>
			</section>

			<section className="bg0 p-t-75 p-b-120">
				<div className="container">
					<div className="row p-b-148">
						<div className="col-md-7 col-lg-8">
							<div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
								<h3 className="mtext-111 cl2 p-b-16">Our Story</h3>
								<p className="stext-113 cl6 p-b-26">It all started with a "what if?"</p>
								<p className="stext-113 cl6 p-b-26">Kryptonian Labs began with a simple chit chat between a small group of friends who shared a love for cars and a frustration with how difficult it was to buy one honestly — the kind of conversation where ideas are shared freely, without pressure or expectation. What started as "it would be nice if there was a dealership you could actually trust…" slowly turned into "why don't we actually build it?" And in that moment, we realized that sometimes, the best way to bring an idea to life is simply to start.</p>
								<p className="stext-113 cl6 p-b-26">So we did.</p>
								<p className="stext-113 cl6 p-b-26">With a lot of hope and very small steps, we began working on Kryptonian Labs on 23rd August 2025. There was no rush, no pressure — only belief, care, and the joy of building something together. Every decision, every inspection, every car we chose to list came from a place of honesty, curiosity, and pride in the work. Car by car, sale by sale, we allowed the dealership to grow naturally, learning along the way and celebrating each small milestone.</p>
							</div>
						</div>
						<div className="col-11 col-md-5 col-lg-4 m-lr-auto">
							<div className="how-bor1">
								<div className="hov-img0">
									<img src="asset/images/about-04.png" alt="Sedan on the showroom floor" />
								</div>
							</div>
						</div>
					</div>

					<div className="row p-b-148">
						<div className="order-md-2 col-md-7 col-lg-8 p-b-30">
							<div className="p-t-7 p-l-85 p-l-15-lg p-l-0-md">
								<h3 className="mtext-111 cl2 p-b-16">Our Philosophy</h3>
								<p className="stext-113 cl6 p-b-26">Our lineup is shaped by real driving lives — the daily commute, the weekend road trip, and everything in between. From dependable everyday runabouts to cars built for the open road, we choose vehicles that move with life itself. Every car on our lot is picked with the driver in mind, so you can feel confident, comfortable, and proud of what you drive.</p>
								<p className="stext-113 cl6 p-b-26">At Kryptonian Labs, we believe buying a car shouldn't feel like a gamble — it's about the trust you drive away with. Our goal is to make every step of the process transparent, so you can make a decision with confidence and enjoy the moments a good car makes possible. Every inspection, every service record, and every price is handled with thought and care, so the car you choose can go the distance with you, near or far.</p>
								<p className="stext-113 cl6 p-b-26">As we grow, our promise remains simple: to offer the best vehicles we can find, to keep improving how we serve our customers, and to offer a wide selection that lets you find the right car without the runaround. This is more than a dealership — it is a promise of honesty, care, and the pride of doing right by every customer.</p>
								<p className="stext-113 cl6 p-b-26">This is Kryptonian Labs, built by friends, with hope, built slowly, and driven with trust.</p>
							</div>
						</div>
						<div className="order-md-1 col-11 col-md-5 col-lg-4 m-lr-auto p-b-30">
							<div className="how-bor2">
								<div className="hov-img0">
									<img src="asset/images/about-03.png" alt="Car parked at the dealership" />
								</div>
							</div>
						</div>
					</div>

					<div className="row p-b-148">
						<div className="col-md-7 col-lg-8">
							<div className="p-t-7 p-r-85 p-r-15-lg p-r-0-md">
								<div className="bor16 p-l-29 p-b-9 m-t-22">
									<h3 className="mtext-111 cl2 p-b-16">Our Inspiration</h3>
									<p className="stext-114 cl6 p-r-40 p-b-11">Quality means doing it right when no one is looking. That's the standard we hold every car to — every inspection, every service record, every detail — long before it ever reaches our showroom floor.</p>
									<span className="stext-111 cl8">- Henry Ford</span>
								</div>
							</div>
						</div>
						<div className="col-11 col-md-5 col-lg-4 m-lr-auto">
							<div className="how-bor1">
								<div className="hov-img0">
									<img src="asset/images/about-05.png" alt="Vehicle detail shot at the dealership" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<Footer />
			<BackToTop />
		</div>
	);
};

export default About;